// page: string;
// pageBlockFind: string;
// pageBlockCreateDefault: string;
// pageBlockUpdate: string;
// pageBlockPreview: string;
// pageBlockUpdateInactivate: string;
// pageBlockUpdateActive: string;
// export const permissionsKeys = {
//   page: 'page-config.header-objects',
//   pageBlockUpdate: 'page-config.header-objects.page-version.clonePageVersion', //se esta usando la llave update para no modificar la estructura d ela interfaz, pero podria ser pageBlockClonePageVersion
//   pageBlockPreview: 'page-config.header-objects.page-block.preview',
//   pageBlockUpdateInactivate: 'page-config.header-objects.inactivate.page-block.update',
//   pageBlockUpdateActive: 'page-config.header-objects.active.page-block.update',
//   pageBlockCreateDefault: 'page-config.header-objects.page-block.create.default', //no se usa
//   pageBlockFind: 'page-config.header-objects.page-block.find',
// };

// 6:"page-config.footer-objects.page-block.find"
// 7:"page-config.footer-objects.page-block.update"
// 8:"page-config.footer-objects.page-block.preview"
// 9:"page-config.footer-objects.inactivate.page-block.update"
// 10:"page-config.footer-objects.active.page-block.update"

export const permissionsKeys = {
  page: 'page-config.footer-objects',
  pageBlockFind: 'page-config.footer-objects.page-block.find',
  pageBlockUpdate: 'page-config.footer-objects.page-block.update',
  pageBlockPreview: 'page-config.footer-objects.page-block.preview',
  pageBlockUpdateInactivate: 'page-config.footer-objects.inactivate.page-block.update',
  pageBlockUpdateActive: 'page-config.footer-objects.active.page-block.update',
  pageBlockCreateDefault: 'page-config.footer-objects.page-block.create.default', //no se usa
} as const;
